import styled from "styled-components";

export const TooltipChats = styled.h4`
  background-color: ${({ theme }) => theme.background};
  padding: 5px 5px;
  box-shadow: 0px 3px 6px ${({ theme }) => theme.blackShadow}29;
  font-family: "Nunito Sans ExtraBold";
  border-radius: 15px;
  overflow: auto;
  max-height: 250px;
  .box-chat {
    border-radius: 5px;
    color: ${({ theme }) => theme.primaryColor};
    display: flex;
    height: 40px;
    box-sizing: border-box;
    font-size: 13px;
    font-family: "Nunito Bold";
    cursor: pointer;
    min-width: 120px;
    padding: 5px 10px;
    .name-chat {
      color: ${({ theme }) => theme.primaryColor} !important;
      align-self: center;
    }
    &:hover {
      background-color: ${({ theme }) => theme.hoverGrey};
    }
  }
`;
